import PropTypes from 'prop-types';
import React from 'react';

import { Color } from '../../../shared/constants/Colors';
import * as S from './Badge.styles';

export const BadgeAppearance = {
  OUTLINE: 'outline',
  MINIMAL: 'minimal',
};

export const Badge = ({ children, appearance, color }) => {
  if (!children) {
    return null;
  }

  return (
    <S.StyledBadge appearance={appearance} color={color}>
      {children}
    </S.StyledBadge>
  );
};

Badge.propTypes = {
  /**
   * Set the appareance of the badge.
   */
  appearance: PropTypes.oneOf(Object.values(BadgeAppearance)),
  /**
   * The displayed content of the button.
   */
  children: PropTypes.node.isRequired,
  /**
   * Set the badge color
   */
  color: PropTypes.string,
};

Badge.defaultProps = {
  appearance: BadgeAppearance.MINIMAL,
  color: Color.CLOUD_BURST,
};
